import React, { useEffect, useState } from 'react';
import BasePage from '../BasePage';
import { DataTableColumn } from 'mantine-datatable';
import Task from '../../interfaces/Task';
import { coreApi } from '../../utils/CoreAPI';
import ResponsiveTable from '../../components/ResponsiveTable';

function AutomationsPage() {
    const [tasks, setTasks] = useState<Task[]>([]);

    const getTasks = async () => {
        const response = await coreApi.get('automations/tasks');

        setTasks(response.data);
    };

    useEffect(() => {
        getTasks();
    }, []);

    const columns: DataTableColumn<Task>[] = [
        { accessor: "id", title: "Task ID", sortable: true },
        { accessor: "name", title: "Name", sortable: true },
        { accessor: "task", title: "Task", sortable: true },
        { accessor: "total_run_count", title: "Run Count", sortable: true },
    ];

    return (
        <BasePage
            fullWidth
            breadcrumbs={[
                { label: "Automations" },
            ]}
        >
            <ResponsiveTable
                data={tasks}
                columns={columns}
                gridRowId={(row) => row.id}
                // onRowClick={(row) => { handleUserViewDetails(row) }}
                gridSortModel={{
                    columnAccessor: "displayName",
                    direction: "asc",
                }}
                selectionColumnStyle={{ display: 'none' }}
            />
        </BasePage>
    )
};

export default AutomationsPage;